module.exports = __webpack_public_path__ + "media/images/pencil-blue-line-2-dark-e71d78bdef325ed0345376a619df7807.png";